export default __webpack_public_path__ + "static/media/android.53b63277.svg";